export default __webpack_public_path__ + "static/media/8.a94e37bb.png";